import { StepsButtons } from "@/components/button/steps-button";
import { useSupermarket } from "@/features/lifestyle/hooks/use-supermarket";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { IonSkeletonText } from "@ionic/react";
import { AnimatedOnboardingContainer } from "../../components/animated-onboarding-container";
import { setMixpanelOnboardingEvent } from "../../utils/mixpanel-onboarding";
import { setSmartlookOnboardingEvent } from "../../utils/smartlook-onboarding";
import { SupermarketCard } from "./supermarket-card";

const brandLogosMap: Record<string, string | undefined> = {
  Asda: "/assets/icons/supermarket/asda.svg",
  "M&S": "/assets/icons/supermarket/ms.svg",
  "Sainsbury's": "/assets/icons/supermarket/sainsburys.svg",
  Tesco: "/assets/icons/supermarket/tesco.svg",
  Lidl: "/assets/icons/supermarket/lidl.svg",
  Aldi: "/assets/icons/supermarket/aldi.svg",
  Morrisons: "/assets/icons/supermarket/morrisons.svg",
  Waitrose: "/assets/icons/supermarket/waitrose.svg",
} as const;

const OnboardingSupermarket = () => {
  const { info, navigateToNextStep } = useStepRouteInfo();

  const { options, selectedOptions, isLoading, handlePreferenceSelect, handleSubmit, isUpdating } =
    useSupermarket({
      onSuccess: () => {
        setSmartlookOnboardingEvent({
          type: "submit",
          stepPath: info?.path,
        });
        setMixpanelOnboardingEvent({
          type: "submit",
          stepPath: info?.path,
        });
        navigateToNextStep();
      },
    });

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit();
  };

  if (isLoading) {
    return (
      <AnimatedOnboardingContainer
        title="Where do you usually shop?"
        classNames={{
          container: "flex-1 h-full flex flex-col",
          form: "flex-1 flex flex-col",
        }}
      >
        <div className="flex flex-1 flex-col items-center justify-center">
          <div className="flex flex-1 flex-col items-center justify-center">
            <div className="grid w-full grid-cols-3 content-start gap-3">
              {Array.from({ length: 9 }).map((_, i) => (
                <IonSkeletonText key={i} animated className="h-[97px] w-[97px] rounded-[12px]" />
              ))}
            </div>
          </div>
          <StepsButtons previousPath={info?.previousPath} type="submit" disabled={true} />
        </div>
      </AnimatedOnboardingContainer>
    );
  }

  return (
    <AnimatedOnboardingContainer
      title="Where do you usually shop?"
      handleSubmit={onSubmit}
      classNames={{
        container: "flex-1 h-full flex flex-col",
        form: "flex-1 flex flex-col justify-center items-center",
      }}
    >
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="grid w-full grid-cols-3 content-start gap-3">
          {options?.map((option) => {
            const isSelected = selectedOptions.has(option);
            const logoSrc = brandLogosMap[option];

            return (
              <SupermarketCard
                key={option}
                option={option}
                logoSrc={logoSrc}
                isSelected={isSelected}
                isDisabled={isUpdating}
                onSelect={handlePreferenceSelect(option)}
              />
            );
          })}
        </div>
      </div>

      <StepsButtons type="submit" disabled={isUpdating} />
    </AnimatedOnboardingContainer>
  );
};

export default OnboardingSupermarket;
